module.exports = __webpack_public_path__ + "img/tweet-content.98db8114.png";